import React from 'react';
import connect from "react-redux/es/connect/connect";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";

import styles from 'common/components/style';

import DialogTitle from 'common/components/dialog/DialogTitle';
import DialogContent from 'common/components/dialog/DialogContent';
import DialogActions from 'common/components/dialog/DialogActions';

import ToggleIconButton from "common/components/ToggleIconButton";

import {
  locationsFetchResponse,
  attendanceMonitorLocationsSave,
  attendanceMonitorLocationsSaveResponse,
  attendanceMonitorLocationsEditDone,
  attendanceMonitorLocationsChooserSetIsEnabled,
  attendanceMonitorChooserLocationsResponse,
  attendanceMonitorLocationsEdit
} from 'redux/admin/Actions';

class LocationSelectionDialog extends React.Component {
  constructor(props) {
    super(props);
    this.setSearch = this.setSearch.bind(this);

    this.state = {
      controlsDisabled: false,
      tabIndex: 0,
      searchString: '',
      selectAllChecked: this.getIsAllChecked(props.locations),
    };
  };

  getIsAllChecked(locations) {
    return locations.every(location => location.isAttendanceMonitorEnabled);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const isAllChecked = nextProps.locations.every(location => location.isAttendanceMonitorEnabled);
    if (isAllChecked !== prevState.selectAllChecked) {
      return { selectAllChecked: isAllChecked };
    }
    return null;
  };

  setSearch(event) {
    this.setState({
      searchString: event.target.value
    })
  };

  handleClose = () => {
    this.setState({ searchString: '' });
    if (this.props.attendanceMonitorLocationsEditDone) {
      this.props.attendanceMonitorLocationsEditDone();
    }
  };

  handleSave = () => {
    this.setState({ searchString: '' });
    if (this.props.attendanceMonitorLocationsSave) {
      this.props.attendanceMonitorLocationsSave();
    }
  };

  handleSelectAllChange = () => {
    const { selectAllChecked } = this.state;
    const { attendanceMonitorLocationsChooserSetIsEnabled, locations } = this.props;

    locations.forEach(location => {
      attendanceMonitorLocationsChooserSetIsEnabled({ id: location.id, isEnabled: !selectAllChecked });
    });

    this.setState({ selectAllChecked: !selectAllChecked });
  };

  handleItemToggle = (location) => {
    const { attendanceMonitorLocationsChooserSetIsEnabled, locations } = this.props;
    attendanceMonitorLocationsChooserSetIsEnabled({ id: location.id, isEnabled: !location.isAttendanceMonitorEnabled });
    const allSelected = locations.every(location => location.isAttendanceMonitorEnabled);
    this.setState({ selectAllChecked: allSelected });
  }

  render() {
    if (!this.props.attendanceMonitorLocationsEditor) return null;

    const { classes, locations } = this.props;

    const enabledLocationsCount = locations.filter(location => location.isAttendanceMonitorEnabled).length;
    const totalLocationsCount = locations.length;

    const locationsSorted = locations;
    locationsSorted.sort((a, b) => {
      const aDisplayName = a.name.toLowerCase()
      const bDisplayName = b.name.toLowerCase()
      return bDisplayName < aDisplayName ? 1 : bDisplayName > aDisplayName ? -1 : 0
    });

    const locationsList = locationsSorted.reduce((acc, location) => {
      if (location.name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) > -1) {
        acc.push(
          <ListItem title={`id: ${location.id}`} key={location.id}>
            <ToggleIconButton isOn={location.isAttendanceMonitorEnabled} onClick={() => this.handleItemToggle(location)} />
            {location.name} - {location.displayName}
          </ListItem>
        );
      }
      return acc;
    }, []);

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="location-selection-dialog-title"
        open={true}
        PaperProps={{
          style: { minWidth: '600px' }
        }}
      >
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
          Choose locations
        </DialogTitle>

        <DialogContent className={classes.dialogContentRoot}>
          <Typography style={{ marginTop: '10px' }}>Choose which locations will be used for Attendance Monitor</Typography>
          <Typography style={{ marginBottom: '10px' }}>{enabledLocationsCount} of {totalLocationsCount}.</Typography >
          <TextField
            style={{ marginTop: '10px' }}
            label={`Search for a location`}
            variant="outlined"
            fullWidth
            onKeyUp={this.setSearch}
          />
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', paddingLeft: '16px' }}>
            <Checkbox checked={this.state.selectAllChecked} onChange={this.handleSelectAllChange} />
            <Typography>Select All</Typography>
          </div>
          <List>{locationsList}</List>
        </DialogContent>

        <DialogActions style={{ marginTop: 10 }}>
          <Button onClick={this.handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleSave} color="primary">
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapDispatchToProps = {
  locationsFetchResponse,
  attendanceMonitorLocationsSave,
  attendanceMonitorLocationsSaveResponse,
  attendanceMonitorLocationsEditDone,
  attendanceMonitorLocationsChooserSetIsEnabled,
  attendanceMonitorChooserLocationsResponse,
  attendanceMonitorLocationsEdit
};

const mapStateToProps = state => {
  const locations = state.admin.attendanceMonitorLocationsChooser.locations;
  const attendanceMonitorLocationsEditor = state.admin.dialogs.attendanceMonitorLocationsEditor ? state.admin.dialogs.attendanceMonitorLocationsEditor : null;
  return { locations, attendanceMonitorLocationsEditor };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LocationSelectionDialog));